// setImmediate/clearImmediate for code (bluebird et al) that expects them.
module.exports = {
    setImmediate: (fn, ...args) => setTimeout(fn, 0, ...args),
    clearImmediate: (id) => clearTimeout(id),
};
